import { useState } from 'react';
import { Button, Form, ProgressBar, Alert, Row, Col, Container, Card } from 'react-bootstrap';
import useDeviceScan from '../../hooks/useScan';
import 'bootstrap/dist/css/bootstrap.min.css';
import './DeviceScanControl.css';
import { useTranslation } from 'react-i18next';
import { Paragraph } from 'components/common/SimpleControls/Paragraph';

const DeviceScanControl = () => {
  const [fromDate, setFromDate] = useState<string>('');
  const [hideModal, setHideModal] = useState(true);
  const { scanStatus, error, startScan } = useDeviceScan();
  const { t } = useTranslation();

  const handleStartScan = () => {
    setHideModal(false);
    startScan(fromDate);
  };

  const handleCloseOverlay = () => {
    setHideModal(true);
    // This function can be used to close the overlay if needed
    // For now, it's just a placeholder since the overlay is automatically hidden based on scanStatus
  };

  return (
    <Container className="bg-primary rounded-top border-bottom border-secondary">
      {!hideModal && scanStatus && scanStatus.totalEans > 0 && (
        <Card className="position-fixed top-50 start-50 translate-middle bg-white p-4 rounded-3 shadow-sm z-index-3 w-25">
          <Card.Header className='border-0 bg-transparent'>
            <Card.Title className='text-secondary text-center fs-2 fw-bold'>{t("services.header.status")}: {scanStatus.status}</Card.Title>
          </Card.Header>
          <ProgressBar
            className="scan-progress-bar"
            now={(scanStatus.processedEans / scanStatus.totalEans) * 100}
            label={`${Math.round((scanStatus.processedEans / scanStatus.totalEans) * 100)}%`}
          />
          <Paragraph className="mt-4 text-center fw-medium">
            {t("devices.scan.label.processed", { processedEans: scanStatus.processedEans, totalEans: scanStatus.totalEans })}
          </Paragraph>
          <Paragraph className="text-center fw-medium">
            {t("devices.scan.label.added", { addedEans: scanStatus.addedEans, processedEans: scanStatus.processedEans, totalEans: scanStatus.totalEans })}
          </Paragraph>
          {(scanStatus.status === 'Done' || scanStatus.totalEans === 0) && (
            <Button variant="secondary" className="py-1 fw-medium w-25 position-relative top-0 start-50 translate-middle-x" onClick={handleCloseOverlay}>
              {t("close")}
            </Button>
          )}
        </Card>
      )}

      <div className="d-flex justify-content-center">
        <Form>
          <Row className="align-items-center">
            <Col xs="auto">
              <Form.Label className='text-white fs-4 fw-medium mt-2'>{t("devices.scan.label.fromDate")}</Form.Label>
            </Col>
            <Col xs="auto">
              <Form.Control
                type="datetime-local"
                className='form-control form__field text-center mx-2 fw-medium w-auto bg-white text-uppercase'
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Col>
            <Col xs="auto">
              <Button className="button-scan" onClick={handleStartScan}>
                {t("devices.scan.label.start")}
              </Button>
            </Col>
          </Row>
        </Form>

        {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
      </div>
    </Container>
  );
};

export default DeviceScanControl;
